module.exports = __webpack_public_path__ + "static/img/054_TO8_1595.8387c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/054_TO8_1595.jpg
// module id = vtKk
// module chunks = 0